module.exports = __webpack_public_path__ + "img/pushcandidate.044c6f2d.svg";